// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumEnvironmentOperationType } from './EnumEnvironmentOperationType';
import {
  EnumEnvironmentOperationTypeFromJSON,
  EnumEnvironmentOperationTypeFromJSONTyped,
  EnumEnvironmentOperationTypeToJSON,
  EnumEnvironmentOperationTypeToJSONTyped,
} from './EnumEnvironmentOperationType';
import type { EnumEnvironmentOperationStatus } from './EnumEnvironmentOperationStatus';
import {
  EnumEnvironmentOperationStatusFromJSON,
  EnumEnvironmentOperationStatusFromJSONTyped,
  EnumEnvironmentOperationStatusToJSON,
  EnumEnvironmentOperationStatusToJSONTyped,
} from './EnumEnvironmentOperationStatus';

/**
 *
 * @export
 * @interface RequestEnvironmentOperation
 */
export interface RequestEnvironmentOperation {
  /**
   *
   * @type {number}
   * @memberof RequestEnvironmentOperation
   */
  githubWorkflowRunId?: number;
  /**
   *
   * @type {string}
   * @memberof RequestEnvironmentOperation
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof RequestEnvironmentOperation
   */
  name?: string;
  /**
   *
   * @type {EnumEnvironmentOperationStatus}
   * @memberof RequestEnvironmentOperation
   */
  status?: EnumEnvironmentOperationStatus;
  /**
   *
   * @type {EnumEnvironmentOperationType}
   * @memberof RequestEnvironmentOperation
   */
  type?: EnumEnvironmentOperationType;
}

/**
 * Check if a given object implements the RequestEnvironmentOperation interface.
 */
export function instanceOfRequestEnvironmentOperation(
  value: object,
): value is RequestEnvironmentOperation {
  return true;
}

export function RequestEnvironmentOperationFromJSON(
  json: any,
): RequestEnvironmentOperation {
  return RequestEnvironmentOperationFromJSONTyped(json, false);
}

export function RequestEnvironmentOperationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestEnvironmentOperation {
  if (json == null) {
    return json;
  }
  return {
    githubWorkflowRunId:
      json['github_workflow_run_id'] == null
        ? undefined
        : json['github_workflow_run_id'],
    message: json['message'] == null ? undefined : json['message'],
    name: json['name'] == null ? undefined : json['name'],
    status:
      json['status'] == null
        ? undefined
        : EnumEnvironmentOperationStatusFromJSON(json['status']),
    type:
      json['type'] == null
        ? undefined
        : EnumEnvironmentOperationTypeFromJSON(json['type']),
  };
}

export function RequestEnvironmentOperationToJSON(
  json: any,
): RequestEnvironmentOperation {
  return RequestEnvironmentOperationToJSONTyped(json, false);
}

export function RequestEnvironmentOperationToJSONTyped(
  value?: RequestEnvironmentOperation | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    github_workflow_run_id: value['githubWorkflowRunId'],
    message: value['message'],
    name: value['name'],
    status: EnumEnvironmentOperationStatusToJSON(value['status']),
    type: EnumEnvironmentOperationTypeToJSON(value['type']),
  };
}
